<!-- 協會/社 登入後首頁 -->
<template>
	<div aria-busy="true" id="home">
		<div class="workspace" canvas="container">
			<SideNav :role="role"></SideNav>
			<div class="page event-page">
				<div class="page-inner">
					<div class="page-wrapper">
						<header class="header">
							<nav class="navbar navbar-expand-lg navbar-light">
								<button
									class="navbar-toggler"
									type="button"
									data-toggle="collapse"
									data-target="#navbarSupportedContent"
									aria-controls="navbarSupportedContent"
									aria-expanded="false"
									aria-label="Toggle navigation"
								>
									<span class="navbar-toggler-icon"></span>
								</button>
								<div
									class="collapse navbar-collapse"
									id="navbarSupportedContent"
								>
									<!-- <div class="mr-auto">
                                        <form class="form-inline md-form form-sm">
                                            <input class="form-control form-control-md mr-3" type="text" placeholder="Search" aria-label="Search">
                                            <i class="fa fa-search" aria-hidden="true"></i>
                                        </form>
                                    </div>-->
									<div
										class="hideSideNav logo-left"
										v-if="$route.meta.hideSideNav"
									>
										<h1 class="logo">
											<a class="logo__link" href="/home">
												<img
													class="logo__img"
													src="../assets/logo.svg"
													alt="back"
													title="中華民國儲蓄互助協會"
													width="45"
													height="40"
												/>
												<small>管理系統</small>
											</a>
										</h1>
									</div>
									<el-select
										v-model="value"
										placeholder="請選擇代理人"
										:disabled="isAgentMode()"
										:class="{
											ml10: $route.meta.hideSideNav,
										}"
										@change="changeAgent"
									>
										<el-option
											v-for="item in agent"
											:key="item.id"
											:label="item.name"
											:value="item.id"
										></el-option>
									</el-select>
									<el-button
										v-if="isAgentMode()"
										type="warning"
										plain
										class="ml-3"
										@click="exitAgent"
										>結束代理</el-button
									>
									<el-button
										v-if="isSupMode()"
										type="primary"
										plain
										class="ml-3"
										@click="backSup"
										>返回協會督導</el-button
									>
									<ul class="navbar-nav nav-right ml-md-auto">
										<li class="nav-item dropdown">
											<span
												class="counter"
												v-if="unreadCount > 0"
												>{{ unreadCountText }}</span
											>
											<a
												class="
													notifications-dropdown
													dropdown-toggle
													nav-link
													no-after
												"
												data-toggle="dropdown"
												aria-expanded="false"
												@click="openNotify"
											>
												<i class="fa fa-bell-o"></i>
											</a>
											<ul
												class="dropdown-menu sys-notify"
											>
												<li class="dropdown-head">
													<i class="fa fa-bell-o"></i>
													<span>通知</span>
												</li>
												<li
													v-if="sysNotify.length > 0"
													class="noti-content"
												>
													<ul class="has-row">
														<li
															v-for="(
																msg, idx
															) in sysNotify"
															:key="idx"
														>
															<a
																class="
																	dropdown-item
																"
															>
																<div
																	class="
																		peer
																		mr-15
																	"
																>
																	<img
																		src="/assets/default-avatar.svg"
																		alt
																	/>
																</div>
																<div
																	class="
																		peer
																		peer-greed
																	"
																>
																	<div
																		class="
																			flex
																			between
																		"
																	>
																		<p>{{msg.message}}</p>
																		<!-- 計算日期差距 若上一級 < 0 則減少一級計算 -->
																		<small
																			class="
																				ml10
																			"
																			v-if="
																				moment(
																					new Date()
																				).diff(
																					msg.recvTime,
																					'months'
																				) >
																				0
																			"
																		>{{
																			moment(
																				new Date()
																			).diff(
																				msg.recvTime,
																				"months"
																			)
																		}}個月前</small>
																		<small
																			class="
																				ml10
																			"
																			v-if="
																				moment(
																					new Date()
																				).diff(
																					msg.recvTime,
																					'weeks'
																				) >
																				0
																			"
																		>{{
																			moment(
																				new Date()
																			).diff(
																				msg.recvTime,
																				"weeks"
																			)
																		}}周前</small>
																		<small
																			class="
																				ml10
																			"
																			v-else-if="
																				moment(
																					new Date()
																				).diff(
																					msg.recvTime,
																					'days'
																				) >
																				0
																			"
																		>{{
																			moment(
																				new Date()
																			).diff(
																				msg.recvTime,
																				"days"
																			)
																		}}天前</small>
																		<small
																			class="
																				ml10
																			"
																			v-else-if="
																				moment(
																					new Date()
																				).diff(
																					msg.recvTime,
																					'hours'
																				) >
																				0
																			"
																		>{{
																			moment(
																				new Date()
																			).diff(
																				msg.recvTime,
																				"hours"
																			)
																		}}小時前</small>
																		<small
																			class="
																				ml10
																			"
																			v-else-if="
																				moment(
																					new Date()
																				).diff(
																					msg.recvTime,
																					'minutes'
																				) >
																				0
																			"
																		>{{
																			moment(
																				new Date()
																			).diff(
																				msg.recvTime,
																				"minutes"
																			)
																		}}分鐘前</small>
																	</div>
																	<!-- <span class="summary">{{msg.message}}</span> -->
																</div>
															</a>
														</li>
													</ul>
												</li>
												<li v-else>
													<p class="center">
														暫無通知
													</p>
												</li>
												<li class="dropdown-foot">
													<div class="view-all">
														<router-link
															:to="{
																name: 'sysnotify',
															}"
														>
															查看全部通知
															<i
																class="
																	fa
																	fa-angle-right
																"
															></i>
														</router-link>
													</div>
												</li>
											</ul>
										</li>
										<li class="nav-item dropdown">
											<a
												class="
													nav-link
													dropdown-toggle
													peers
												"
												id="navbarDropdown"
												role="button"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
											>
												<div class="peer">
													<img
														class="w-2r bdrs-50p"
														src="/assets/default-avatar.svg"
														alt
													/>
												</div>
												<span class="peer username">
													{{ user.name }}
												</span>
											</a>
											<div
												class="dropdown-menu"
												aria-labelledby="navbarDropdown"
											>
												<router-link
													:to="{
														name: 'person_information',
													}"
													class="dropdown-item"
													>個人資料管理</router-link
												>
												<a
													href="/中華民國儲蓄互助協會-儲互社操作手冊.pdf"
													class="dropdown-item"
													download
													>操作手冊下載</a
												>
												<a
													href="/edu.pdf"
													class="dropdown-item"
													download
													>教育訓練用PDF</a
												>
												<router-link
													:to="{
														name: 'association_agent',
													}"
													class="dropdown-item"
													v-if="role == 'association'"
													>代理人設定</router-link
												>
												<div
													class="dropdown-divider"
												></div>
												<a
													class="dropdown-item"
													@click="logout"
													>登出</a
												>
											</div>
										</li>
										<li class="nav-item">
											<a
												class="
													js-toggle-right-slidebar
													nav-link
													blue-gradient
												"
												>切換</a
											>
										</li>
									</ul>
								</div>
							</nav>
						</header>
						<div class="content-wrapper clearfix">
							<!-- CULROC_admin: Demo Sidebar -->
							<breadcrumbs></breadcrumbs>
							<main class="main">
								<!-- 首頁 -->
								<div v-if="$route.meta.mainHome">
									<div class="row">
										<!-- 工作訊息 -->
										<div class="col-6">
											<div class="col-block">
												<div
													class="
														block-header
														has-border
													"
												>
													<h3>本日工作訊息通知</h3>
													<div
														class="
															block-options
															pull-right
														"
													>
														<el-button
															size="mini"
															plain
															@click="
																go(
																	'work_manage'
																)
															"
															>切換列表檢視</el-button
														>
													</div>
												</div>
												<div
													class="block-content max450"
												>
													<div
														class="
															timeline
															block-timeline
														"
													>
														<ul>
															<li
																v-for="item in getAllWorkNotify"
																:key="item.id"
																:class="{
																	'time-warning':
																		item.level_key ==
																		2,
																	'time-danger':
																		item.level_key ==
																		3,
																}"
															>
																<div
																	class="
																		timeline-circ
																	"
																></div>
																<div
																	class="card"
																>
																	<div
																		class="
																			card-body
																			small-padding
																		"
																	>
																		<span
																			class="
																				timeline-date
																			"
																		>
																			<i
																				class="
																					fa
																					fa-clock-o
																				"
																				aria-hidden="true"
																			></i>
																			{{
																				item.start_date.substr(
																					0,
																					4
																				) -
																				1911
																			}}
																			年
																			{{
																				item.start_date.substr(
																					5,
																					2
																				)
																			}}
																			月
																			{{
																				item.start_date.substr(
																					8,
																					2
																				)
																			}}
																			日
																			,{{
																				item.start_date
																					| getDay
																			}}
																			<el-button
																				class="
																					viewItemBtn
																				"
																				@click="
																					(dialogVisible = true),
																						openModal(
																							item
																						)
																				"
																				>查看</el-button
																			>
																		</span>
																		<span
																			class="
																				text-medium
																			"
																		>
																			<!-- {{item.caption}} -->
																			<span
																				class="
																					info
																				"
																			>
																				{{
																					item.caption
																				}}
																			</span>
																			<!-- <a :href="item.url">{{item.html_content}}</a> -->
																		</span>
																	</div>
																</div>
															</li>
														</ul>
													</div>
												</div>
											</div>
										</div>
										<!-- 公告 -->
										<div class="col-6 announcement">
											<div class="col-block">
												<div
													class="
														block-header
														has-border
													"
												>
													<h3>公告</h3>
												</div>
												<div
													class="
														block-content
														expansion
													"
												>
													<div
														class="max450"
														style="
															max-height: 422px;
														"
													>
														<table class="table">
															<tbody>
																<tr
																	v-for="(
																		item,
																		index
																	) in getAnnouncement"
																	:key="index"
																>
																	<td
																		v-if="
																			item.setTop ===
																			1
																		"
																	>
																		置頂
																	</td>
																	<td
																		v-else
																	></td>
																	<td>
																		<a
																			v-html="
																				item.caption
																			"
																			@click.prevent="
																				openAnnouncementModal(
																					item
																				)
																			"
																		></a>
																	</td>
																	<td>
																		{{
																			item.publishTime
																				? parseInt(
																						item.publishTime.split(
																							"-"
																						)[0]
																				  ) -
																				  1911 +
																				  item.publishTime.slice(
																						4
																				  )
																				: ""
																		}}
																	</td>
																</tr>
															</tbody>
														</table>
													</div>
													<el-pagination
														layout="prev, pager, next"
														:total="
															pagination.totalCount
														"
														style="
															text-align: center;
														"
														:page-sizes="[
															10, 15, 20, 25, 30,
															50,
														]"
														:current-page="
															pagination.currentPage
														"
														:totalPages="
															pagination.totalPages
														"
														@current-change="
															announcement($event)
														"
													></el-pagination>
												</div>
											</div>
										</div>
										<!-- 放款業務通知 -->
										<!-- <div class="col-6"
                                             v-if="role == 'coop'">
                                            <div class="col-block">
                                                <div class="block-header has-border">
                                                    <h3>放款業務通知</h3>
                                                    <div class="block-options pull-right">
                                                        <el-button size="mini"
                                                                   plain>切換列表檢視</el-button>
                                                    </div>
                                                </div>
                                                <div class="block-content max450">
                                                    <div class="timeline block-timeline">
                                                        <ul>
                                                            <li class="time-warning">
                                                                <div class="timeline-circ"></div>
                                                                <div class="card">
                                                                    <div class="card-body small-padding">
                                                                        <span class="timeline-date">
                                                                            <i class="fa fa-clock-o"
                                                                               aria-hidden="true"></i> 2018 年 5 月 3 日, 星期四
                                                                        </span>
                                                                        <span class="text-medium">
                                                                            撥貸
                                                                            <a href="###">(Approval or Signing Contracts)</a>
                                                                            <span class="info">簽發文件</span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="timeline-circ"></div>
                                                                <div class="card">
                                                                    <div class="card-body small-padding">
                                                                        <span class="timeline-date">
                                                                            <i class="fa fa-clock-o"
                                                                               aria-hidden="true"></i> 2018 年 5 月 3 日, 星期四
                                                                        </span>
                                                                        <span class="text-medium">
                                                                            擔保品設定登記
                                                                            <a href="###">(Registration of First Priority Mortgage)</a>
                                                                            <span class="info">投保保險</span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li class="time-success">
                                                                <div class="timeline-circ"></div>
                                                                <div class="card">
                                                                    <div class="card-body small-padding">
                                                                        <span class="timeline-date">
                                                                            <i class="fa fa-clock-o"
                                                                               aria-hidden="true"></i> 2018 年 5 月 3 日, 星期四
                                                                        </span>
                                                                        <span class="text-medium">
                                                                            簽訂授信契約
                                                                            <a href="###">(Contracts Signing and IdentityVerification)</a>
                                                                            <span class="info">對保</span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li class="time-danger">
                                                                <div class="timeline-circ"></div>
                                                                <div class="card">
                                                                    <div class="card-body small-padding">
                                                                        <span class="timeline-date">
                                                                            <i class="fa fa-clock-o"
                                                                               aria-hidden="true"></i> 2018 年 5 月 3 日, 星期四
                                                                        </span>
                                                                        <span class="text-medium">
                                                                            必要時召集放款審議
                                                                            <a href="###">(Call for Loan Review Committee Meeting)</a>
                                                                            <span class="info">小組審議</span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>-->
										<!-- 安基業務通知 -->
										<!-- <div class="col-6"
                                            v-if="role == 'coop'">
                                            <div class="col-block">
                                                <div class="block-header has-border">
                                                    <h3>安基業務通知</h3>
                                                    <div class="block-options pull-right">
                                                        <el-button size="mini"
                                                            plain>切換列表檢視</el-button>
                                                    </div>
                                                </div>
                                                <div class="block-content max450">
                                                    <div class="timeline block-timeline">
                                                        <ul>
                                                            <li class="time-warning">
                                                                <div class="timeline-circ"></div>
                                                                <div class="card">
                                                                    <div class="card-body small-padding">
                                                                        <span class="timeline-date">
                                                                            <i class="fa fa-clock-o"
                                                                                aria-hidden="true"></i> 2018 年 5 月 3 日, 星期四
                                                                        </span>
                                                                        <span class="text-medium">
                                                                            儲互社幹部
                                                                            <a href="###">(Use Case diagram)</a>
                                                                            <span class="info">保險</span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="timeline-circ"></div>
                                                                <div class="card">
                                                                    <div class="card-body small-padding">
                                                                        <span class="timeline-date">
                                                                            <i class="fa fa-clock-o"
                                                                                aria-hidden="true"></i> 2018 年 5 月 3 日, 星期四
                                                                        </span>
                                                                        <span class="text-medium">
                                                                            社員
                                                                            <a href="###">防癌險</a>
                                                                            <span class="info">互助基金</span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li class="time-success">
                                                                <div class="timeline-circ"></div>
                                                                <div class="card">
                                                                    <div class="card-body small-padding">
                                                                        <span class="timeline-date">
                                                                            <i class="fa fa-clock-o"
                                                                                aria-hidden="true"></i> 2018 年 5 月 3 日, 星期四
                                                                        </span>
                                                                        <span class="text-medium">
                                                                            區會協會
                                                                            <a href="###">(Public Package)</a>
                                                                            <span class="info">社專職員工保險</span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li class="time-danger">
                                                                <div class="timeline-circ"></div>
                                                                <div class="card">
                                                                    <div class="card-body small-padding">
                                                                        <span class="timeline-date">
                                                                            <i class="fa fa-clock-o"
                                                                                aria-hidden="true"></i> 2018 年 5 月 3 日, 星期四
                                                                        </span>
                                                                        <span class="text-medium">
                                                                            年度綜合損失互助基金年度
                                                                            <a href="###">(Public ActivityPartition)</a>
                                                                            <span class="info">續約</span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>-->
									</div>
									<!-- <button class="btn btn-cyan" style="position: fixed; bottom: 0;right: 0;z-index: 2;" @click="testGet">測試</button> -->
									<!-- <button class="btn btn-cyan" style="position: fixed; bottom: 0;right: 100px;z-index: 2;" @click="test">空資料</button> -->
									<button
										class="btn btn-cyan"
										style="
											position: fixed;
											bottom: 0;
											right: 0;
											z-index: 2;
										"
										@click="openTokenExpired"
                                        v-show="false" 
									>
										超過兩小時沒切換畫面
									</button>
								</div>
								<!-- 其他分頁 -->
								<router-view v-else></router-view>
							</main>
						</div>
					</div>
					<!-- <footer class="footer">
                        <div class="footer-inner">
                            <span class="power">: )</span>
                        </div>
                    </footer>-->
				</div>
			</div>
		</div>
		<SlideBar :role="role"></SlideBar>
		<!-- 超過時間block 畫面 重新登入 -->
		<el-dialog
			title="超過時間未使用，請重新登入"
			:visible.sync="loginForm"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false"
			:center="true"
		>
			<el-form :model="form">
				<el-form-item label="帳號" label-width="60px">
					<el-input
						v-model="form.account"
						@keyup.enter.native="login"
					></el-input>
				</el-form-item>
				<el-form-item label="密碼" label-width="60px">
					<el-input
						v-model="form.password"
						show-password
						@keyup.enter.native="login"
					></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="login">登入</el-button>
			</div>
		</el-dialog>
		<!-- 工作管理Modal 頁面 -->
		<el-dialog
			title="工作"
			:visible.sync="dialogVisible"
			width="30%"
			append-to-body
			class="modal-show"
		>
			<el-form class="el-form--label-top form-box">
				<el-form-item label="標題" label-position="left">
					<el-input
						class="input-set my-2"
						v-model="modalData.caption"
						:disabled="true"
					></el-input>
				</el-form-item>
				<el-form-item label="日期" class="label">
					<span class="fx-box" style="position: relative">
						<input
							type="text"
							name="mingo"
							class="min_go_date startDate1 startDate"
							placeholder="選擇日期"
							ref="datepicker"
							:disabled="true"
						/>
						<span
							class="el-input__prefix"
							style="margin-left: 5px; top: -12px"
						>
							<i class="el-icon-date"></i>
						</span>
					</span>
					~
					<span class="fx-box" style="position: relative">
						<input
							type="text"
							name="mingo"
							class="min_go_date endDate1 endDate"
							placeholder="選擇日期"
							ref="datepicker"
							:disabled="true"
						/>
						<span
							class="el-input__prefix"
							style="margin-left: 5px; top: -12px"
						>
							<i class="el-icon-date"></i>
						</span>
					</span>
				</el-form-item>
				<el-form-item label="內容" class="label">
					<el-input
						type="textarea"
						v-model="modalData.html_content"
						:rows="5"
						:disabled="true"
					></el-input>
				</el-form-item>
				<el-form-item label="相關連結" class="label">
					<a
						:href="modalData.url"
						class="el-button mb-3"
						target="_blank"
						>前往</a
					>
					<el-input
						class="input-set"
						v-model="modalData.url"
						:disabled="true"
					></el-input>
				</el-form-item>
				<el-form-item label="重要程度" class="label">
					<el-input
						class="input-set"
						v-model="levelKey"
						:disabled="true"
					></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">關閉</el-button>
			</span>
		</el-dialog>
		<!-- 通知Modal 頁面 -->
		<el-dialog
			:visible.sync="AnnouncementModal"
			width="30%"
			append-to-body
			:show-close="false"
			class="modal-show"
		>
			<el-form class="el-form--label-top">
				<el-form-item label="公告標題" label-position="left">
					<el-input
						type="textarea"
						class="input-set"
						v-html="AnnouncementModalData.caption"
					></el-input>
				</el-form-item>
				<el-form-item label="公告內文" label-position="left">
					<el-input
						type="textarea"
						v-html="AnnouncementModalData.htmlContent"
					></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button
					type="primary"
					plain
					@click="AnnouncementModal = false"
					>關閉</el-button
				>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import { slidebar } from "../assets/slidebars.scripts.js";
import { datepickerTw } from "../assets/datepickerTW.js";
import SlideBar from "../components/SlideBar.vue";
import SideNav from "../components/SideNav.vue";
import Breadcrumbs from "../components/Breadcrumbs.vue";
import { API } from "@/assets/config";
import datepickerFactory from "jquery-datepicker";
import moment from "moment";

datepickerFactory($);
export default {
	name: "home",
	components: {
		SlideBar,
		SideNav,
		Breadcrumbs,
	},
	data() {
		return {
			// association協會 coop儲互社
			role: localStorage.role || "association",
			api: "",
			// 代理人下拉選單
			options: [
				{
					value: "选项1",
					label: "黄金糕",
				},
				{
					value: "选项2",
					label: "双皮奶",
				},
				{
					value: "选项3",
					label: "蚵仔煎",
				},
				{
					value: "选项4",
					label: "龙须面",
				},
				{
					value: "选项5",
					label: "北京烤鸭",
				},
			],
			modalData: [],
			value: "",
			form: {
				account: "",
				password: "",
			},
			loginForm: false,
			countdownid: null,
			countdownnumber: 7200,
			// 代理人
			agent: [],
			// 使用者
			user: {},
			// 未讀通知數量
			unreadCount: 0,
			// 訊息
			sysNotify: [],
			//時間格式、顯示狀態轉換
			getAllWorkNotify: [], // 取得所有工作
			tranferNotify: [], //工作狀態為
			generalNotify: [], //工作狀態為一般
			importantNotify: [], //工作狀態為重要
			veryImportantNotify: [], //工作狀態為非常重要
			dialogVisible: false, //modal開關
			getAnnouncement: [], //取得公告
			pagination: {
				currentPage: 1,
				totalCount: 0,
				totalPages: 0,
			},
			AnnouncementModal: false,
			AnnouncementModalData: {},
			testn: "",
			loginIp: "",
		};
	},
	created() {
		if (this.role === "coop") {
			this.api = "coopTask";
		} else {
			this.api = "assnTask";
			localStorage.removeItem("supMode");
		}
		// 取得代理人
		this.getAgent();
		// 取得使用者
		this.getUser();
		// 取得未讀訊息數量（訊息內容於點開通知時才查詢）
		this.getUnreadSysNotifyCount();
		// 取得工作訊息通知
		this.getWorkNotify();
		// 取得公告
		this.announcement();
		// 設定header 寬度
		this.setHeaderCss();
	},
	mounted() {
		slidebar();
		datepickerTw();
		$(".min_go_date").datepicker({
			changeYear: true,
			changeMonth: true,
			currentText: "今天",
			dateFormat: "Rmmdd",
			showButtonPanel: true,
			yearRange: "1912:c+10",
		});
		// 理事會審查日期
		$(".councilAuditDate").datepicker("option", "maxDate", "+0m +0w");
		// this.initTokenTime();
	},
	watch: {
		$route(to, from) {
			// this.initTokenTime();
			// 每次切換頁面只更新未讀數量，不撈訊息內容
			this.getUnreadSysNotifyCount();
			// 每次換頁綁定民國年事件
			setTimeout(() => {
				$(".min_go_date").datepicker({
					changeYear: true,
					changeMonth: true,
					currentText: "今天",
					dateFormat: "Rmmdd",
					showButtonPanel: true,
					yearRange: "1912:c+10",
				});
				// 理事會審查日期
				$(".councilAuditDate").datepicker(
					"option",
					"maxDate",
					"+0m +0w"
				);
			}, 0);
			// 設定header 寬度
			this.setHeaderCss();
			if (from.name == "super_coop_search") {
				if (localStorage.getItem("role") !== "association") {
					location.reload();
					localStorage.setItem("supMode", true);
				} else {
				}
			}
		},
		tokenExpired() {
			this.tokenWatcher();
		},
	},
	computed: {
		tokenExpired() {
			return this.$store.state.tokenExpired;
		},
		// 未讀數量後端以 UNREAD_COUNT_LIMIT 為上限，達上限時顯示 99+
		unreadCountText() {
			return this.unreadCount >= 100 ? "99+" : this.unreadCount;
		},
		levelKey() {
			if (this.modalData.level_key === 1) {
				return "一般";
			} else if (this.modalData.level_key === 2) {
				return "重要";
			} else if (this.modalData.level_key === 3) {
				return "非常重要";
			}
		},
	},
	methods: {
		moment() {
			return moment();
		},
		isSupMode() {
			if (localStorage.getItem("supMode")) {
				return true;
			} else {
				return false;
			}
		},
		backSup() {
			const form = new FormData();
			let url = API.auth;
			form.append("tokenId", JSON.parse(localStorage.User).tokenId);
			form.append("coopId", 0);
			this.$http
				.put(url, form, {
					headers: { "Content-Type": "multipart/form-data" },
				})
				.then((res) => {
					localStorage.setItem(
						"User",
						JSON.stringify({
							...JSON.parse(localStorage.User),
							coopId: res.data.resultData.coopId,
							sysPermMenu: res.data.resultData.sysPermMenu,
							tokenId: JSON.parse(localStorage.User).tokenId,
						})
					);
					let coopId = JSON.parse(localStorage.subUser).coopId;

					localStorage.setItem("role", "association");
					localStorage.removeItem("supMode");
					localStorage.removeItem("subUser");

					setTimeout(() => {
						location.reload();
					}, 100);
					this.$router.push({
						name: "super_coop_search",
						params: {
							id: coopId,
						},
					});
				})
				.catch((error) => {});
		},
		logout() {
			const url = API.auth + `?action=logout`;
			const form = new FormData();
			let thenCB = (json) => {
				localStorage.removeItem("coopId");
				localStorage.removeItem("User");
				localStorage.removeItem("AgentUser");
				localStorage.removeItem("AgentTargetUserId");
				localStorage.removeItem("AgentTargetUserName");
				if (localStorage.getItem("supMode")) {
					localStorage.removeItem("supMode");
				}
				this.go("login");
			};
			this.mAxiosGet(url, thenCB);
		},
		go(name, query) {
			this.$router.push({ name: name, query: { type: query } });
		},
		login() {
			// this.initTokenTime();
			this.$nextTick(() => {
				delete this.$http.defaults.headers.common["X-Jesda-Api-Key"];

				try {
					this.checkField();
				} catch (error) {
					this.$message.error(error.message);
					return;
				}

				const form = new FormData();

				form.append("account", this.form.account);
				form.append("password", this.form.password);
				form.append(
					"macAddress",
					"aTXIiFqbKo4UTHrSWd4H+iYEKdU4BNyHFfaaUohUzbQ="
				);
                form.append("loginIp", this.loginIp);

				let thenCB = (json) => {
					localStorage.removeItem("User");
					localStorage.setItem(
						"User",
						JSON.stringify(json.resultData.data)
					);
					localStorage.removeItem("AgentUser");
					localStorage.removeItem("AgentTargetUserId");
					localStorage.removeItem("AgentTargetUserName");
					if (json.resultData.data.coopId == 0) {
						// 協會
						localStorage.setItem("role", "association");
					} else {
						// 儲互社
						localStorage.setItem("role", "coop");
						localStorage.setItem("coopId", json.resultData.data.coopId);
					}
					// this.$router.push({ name: 'home' })
					this.loginForm = false;
					// 暫時寫登入後重整
					window.location.reload();
				};
				this.mAxiosPost(API.auth, form, thenCB);
			});
		},
		checkField() {
			if (!this.form.account) {
				throw new Error("請填寫帳號");
			}

			if (!this.form.password) {
				throw new Error("請填寫密碼");
			}
		},
		tokenWatcher() {
			if (API.auth.includes("www.cub.org.tw")) {
				delete this.$http.defaults.headers.common["X-Jesda-Api-Key"];
				this.getClientIp();
			}
			this.loginForm = true;
		},
		// 重新倒數 token 時間 暫時拿掉
		initTokenTime() {
			// this.countdownnumber = 7200;
			// this.$store.dispatch("closeTokenExpired");
			// this.countdownfunc();
		},
		// 倒數計時 暫時拿掉
		countdownfunc() {
			// console.log(this.countdownnumber, this.tokenExpired)
			// if (this.countdownnumber == 0) {
			//     this.$store.dispatch("openTokenExpired");
			//     // console.log(this.countdownnumber, this.tokenExpired)
			//     clearTimeout(this.countdownid);
			// } else {
			//     this.countdownnumber--;
			//     if (this.countdownid) {
			//         clearTimeout(this.countdownid);
			//     }
			//     this.countdownid = setTimeout(this.countdownfunc, 1000);
			// }
		},
		/**
		 * 取得代理人
		 */
		async getAgent() {
			const url = new URL(API.agent);
			url.searchParams.append('action', 'getUserAgent');

			try {
				const json = await this.mAxiosGet(url.toString());

				const list =
					json && json.resultData ? json.resultData.data : null;
				this.agent = Array.isArray(list) ? list : [];
			} catch (error) {
				console.error("Failed to get data in getAgent.");
				return;
			}

			// 還原先前選取的代理人，localStorage 取用失敗時清空
			try {
				const saved = localStorage.getItem("AgentTargetUserId");
				if (saved) {
					const sid = Number(saved);
					this.value = Number.isNaN(sid) ? "" : sid;

					if (!Number.isNaN(sid) && Array.isArray(this.agent)) {
						const matched = this.agent.find(
							(u) => Number(u && u.id) === sid
						);
						if (matched && matched.name) {
							localStorage.setItem(
								"AgentTargetUserName",
								matched.name
							);
						}
					}

					if (!Number.isNaN(sid) && sid) {
						const exist =
							Array.isArray(this.agent) &&
							this.agent.some((u) => Number(u && u.id) === sid);
						if (!exist) {
							const savedName =
								localStorage.getItem("AgentTargetUserName") ||
								"";
							if (savedName) {
								this.agent = [
									{ id: sid, name: savedName },
								].concat(this.agent || []);
							}
						}
					}
				} else {
					this.value = "";
				}
			} catch (e) {
				this.value = "";
			}
		},
		changeAgent(id) {
			const url = API.auth + `?action=agent&userId=${id}`;
			const thenCB = (json) => {
				localStorage.setItem("AgentTargetUserId", String(id));
				try {
					let agentName = "";
					if (Array.isArray(this.agent)) {
						const target = this.agent.find(
							(u) => Number(u && u.id) === Number(id)
						);
						agentName = target && target.name ? target.name : "";
					}
					if (agentName) {
						localStorage.setItem("AgentTargetUserName", agentName);
					} else {
						localStorage.removeItem("AgentTargetUserName");
					}
				} catch (e) {
					localStorage.removeItem("AgentTargetUserName");
				}
				localStorage.removeItem("AgentUser");
				localStorage.setItem(
					"AgentUser",
					JSON.stringify(json.resultData.data)
				);
				// 更新 localStorage.User 為後端返回的資料（代理人的資料結構，但包含被代理人的選單和權限）
				localStorage.removeItem("User");
				localStorage.setItem(
					"User",
					JSON.stringify(json.resultData.data)
				);
				// 重新載入頁面以更新選單和權限
				window.location.reload();
			};
			this.mAxiosGet(url, thenCB);
		},
		exitAgent() {
			const url = API.auth + `?action=exitAgent`;
			const thenCB = (json) => {
				if (json.resultData && json.resultData.data) {
					// 更新 localStorage.User 為代理人的資料
					localStorage.removeItem("User");
					localStorage.setItem(
						"User",
						JSON.stringify(json.resultData.data)
					);
					// 清除 AgentUser
					localStorage.removeItem("AgentUser");
					// 讓下拉選單回到空白並恢復可選
					localStorage.removeItem("AgentTargetUserId");
					localStorage.removeItem("AgentTargetUserName");
					this.value = "";
					// 重新載入頁面以恢復代理人的權限和選單
					window.location.reload();
				}
			};
			this.mAxiosGet(url, thenCB);
		},
		isAgentMode() {
			// 檢查是否在代理模式下（檢查 localStorage.AgentUser 是否存在）
			try {
				// 如果有 AgentUser，表示正在代理模式下
				return localStorage.getItem("AgentUser") !== null;
			} catch (e) {
				return false;
			}
		},
		getUser() {
			this.user = JSON.parse(localStorage.User);
		},
		openTokenExpired() {
			this.$store.dispatch("openTokenExpired");
		},
		closeTokenExpired() {
			this.$store.dispatch("closeTokenExpired");
		},
		/**
		 * 取得未讀訊息數量
		 */
		async getUnreadSysNotifyCount() {
			const url = new URL(API.sysNotify);
			url.searchParams.append('action', 'getUnreadCount');

			try {
				const json = await this.mAxiosGet(url.toString());

				this.unreadCount = json.resultData.unreadCount;
			} catch (error) {
				console.error("Failed to get data in getUnreadSysNotifyCount.");
			}
		},
		/**
		 * 取得未讀訊息清單
		 */
		async getUnreadSysNotify() {
			const url = new URL(API.sysNotify)
            url.searchParams.append('action', 'getList');
            url.searchParams.append('where', JSON.stringify({ filter: {viewed: 0} }));

			try {
                const json = await this.mAxiosGet(url.toString());

                this.sysNotify = json.resultData.data;
            } catch (error) {
                console.error("Failed to get data in getUnreadSysNotify.");
            }
		},
		
		/**
		 * 取得工作訊息通知
		 */
		async getWorkNotify() {
			const url = new URL(this.role === "coop" ? API.CoopIndex : API.AssnIndex);
			const currentDate = moment().format("YYYY-MM-DD");
			url.searchParams.append('action', 'getTaskList');
			url.searchParams.append('calendar', '1');
			url.searchParams.append('start', currentDate);
			url.searchParams.append('end', currentDate);

			try {
				const json = await this.mAxiosGet(url.toString());

				this.getAllWorkNotify = json.resultData.data;
			} catch (error) {
				console.error("Failed to get data in getWorkNotify.");
			}
		},
		openModal(item) {
			const vm = this;
			vm.modalData = item;

			setTimeout(() => {
				$(".min_go_date").datepicker({
					changeYear: true,
					changeMonth: true,
					currentText: "今天",
					dateFormat: "Rmmdd",
					showButtonPanel: true,
				});

				$(".startDate").val(
					`${
						item.start_date
							? item.start_date.split("-")[0] -
							  1911 +
							  item.start_date.slice(4).split(" ")[0]
							: ""
					}`
				);
				$(".endDate").val(
					`${
						item.end_date
							? item.end_date.split("-")[0] -
							  1911 +
							  item.end_date.slice(4).split(" ")[0]
							: ""
					}`
				);
			}, 1);
		},
		openAnnouncementModal(item) {
			const vm = this;
			vm.AnnouncementModalData = item;
			this.AnnouncementModal = true;
		},
		/**
		 * 取得公告
		 * @param {number} page 頁碼，預設帶第一頁
		 */
		async announcement(page = 1) {
			const url = new URL(this.role === "coop" ? API.CoopIndex : API.AssnIndex);
			url.searchParams.append('action', 'getAnnouncementList');
			url.searchParams.append('page', `{page:${page}}`);

			try {
				const json = await this.mAxiosGet(url.toString());

				this.getAnnouncement = json.resultData.data;
				this.pagination.totalCount = json.totalCount;
				this.pagination.totalPages = json.totalPages;
			} catch (error) {
				console.error("Failed to get data in announcement.");
			}
		},
		/**
		 * 打開通知時取得訊息並標記為已讀
		 */
		async openNotify() {
			if ($("ul.dropdown-menu").hasClass("show")) {
				return;
			}
			// 打開通知時才撈訊息內容
			await this.getUnreadSysNotify();

			let arr = this.sysNotify.map((item) => {
				return item.id;
			});
			if (arr.length === 0) {
				return;
			}

			const url = API.sysNotify;
			const form = new FormData();
			form.append("idList", JSON.stringify(arr));

			await this.mAxiosPost(url, form);
			// 標記已讀後更新未讀數量
			this.getUnreadSysNotifyCount();
		},
		test() {
			const url = API.coopLplsReport;
			let params = {
				action: "LSStockAmountLimit",
				accountStart: "00001",
				accountEnd: "00003",
				balanceDate: "2020-01-10",
			};
			this.$http
				.get(url, { responseType: "blob", params })
				.then((response) => {
					let blob = new Blob([response.data], {
						type: "application/pdf",
					});
					this.print(blob);
				});
		},
		print(blob) {
			const vm = this;
			var reader = new FileReader(blob);
			reader.onload = function () {
				// Since it contains the Data URI, we should remove the prefix and keep only Base64 string
				var b64 = reader.result.replace(/^data:.+;base64,/, "");
				vm.send(b64);
			};

			// Since everything is set up, let’s read the Blob and store the result as Data URI
			reader.readAsDataURL(blob);
		},
		send(b64) {
			delete this.$http.defaults.headers.common["X-Jesda-Api-Key"];
			const form = new FormData();
			const url = "http://localhost:4330/transfer/print";
			form.append("test", `${b64}`);
			let thenCB = (json) => {};
			this.mAxiosPost(url, form, thenCB);
		},
		setHeaderCss() {
			setTimeout(() => {
				var parentwidth = $(".content-wrapper").width();
				$(".header").width(parentwidth);
			}, 0);
		},
		getClientIp() {
			const url = 'https://www.cloudflare.com/cdn-cgi/trace';
			this.$http
                .get(url)
                .then((data) => {
					data = data.data.trim().split('\n').reduce(function(obj, pair) {
    					pair = pair.split('=');
    					return obj[pair[0]] = pair[1], obj;
  					}, {});
					this.loginIp = data.ip;
                })
		}
	},
};
</script>
<style lang="scss" scoped>
#home {
	.header {
		position: fixed;
	}

	.content-wrapper {
		margin-top: 60px;
	}

	.hideSideNav {
		// position: absolute;

		@media (max-width: 992px) {
			display: none;
		}

		.logo {
			margin: 0;

			.logo__link {
				display: flex;
				align-items: center;

				small {
					padding-left: 10px;
					font-size: 18px;
					color: #151515;
				}
			}
		}
	}

	.announcement {
		table {
			tr {
				td:first-child {
					color: red;
					font-weight: bold;
				}
			}
		}
	}

	.max450 {
		max-height: 450px;
		overflow: scroll;
	}

	.timeline-date {
		position: relative;

		.viewItemBtn {
			position: absolute;
			right: 0;
			top: -15px;
		}
	}

	.input-set {
		-webkit-appearance: none;
		background-color: #fff;
		background-image: none;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		color: #606266;
		display: inline-block;
		font-size: inherit;
		height: 40px;
		line-height: 40px;
		outline: 0;
		padding: 0 15px;
		-webkit-transition: border-color 0.2s
			cubic-bezier(0.645, 0.045, 0.355, 1);
		transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
		width: 100%;
	}
	// 通知高度
	.noti-content {
		height: 500px;
		overflow: scroll;
	}
}
</style>